import { Box, Flex, FormControl, FormHelperText, FormLabel, Text } from '@chakra-ui/react';
import React from 'react';

const InputContainer = ({ children, label, mandatory, error }) => {
  return (
    <FormControl pt={3} w={'full'}>
      <Flex direction="row">
        <FormLabel mb={2} fontSize="sm" color="gray.400" fontWeight="medium" >
          {label}
          {mandatory && <Text as="span" color="red" ml={1}>*</Text>}
        </FormLabel>
      </Flex>
      <Box w="full" zIndex="base" fontSize="sm" fontWeight="medium">
        {children}
      </Box>
      {error && <FormHelperText color="red.400">{error}</FormHelperText>}
    </FormControl>
  );
};

export default InputContainer;
